import { combineReducers } from '@reduxjs/toolkit';
import { reducer as organizationReducer } from 'src/slices/organization';

const rootReducer = combineReducers({
  organization: organizationReducer
});

export default rootReducer;
